module.exports = __webpack_public_path__ + "img/menu_setting.4eb8c975.png";